import { animate, hover } from "motion";

class IconAnimation {
	constructor(el) {
		this.el = el;
		this.canAnimate = true;
		this.hoverCleanup = null;
		this.timeout = null;
		this.animation = null;

		this.animationType = this.el.getAttribute("data-icon-animation");

		if (typeof this[this.animationType] !== "function") {
			console.log(`no animation for ${this.animationType}`);
			return;
		}

		this.getAnimationElement();
		this[this.animationType]();
	}

	getAnimationElement() {
		this.animationElement = this.el;

		const possibleTarget = this.el.querySelector(".animation-target");

		if (possibleTarget) {
			this.animationElement = possibleTarget;
		}
	}

	setupHover(callback) {
		this.hoverCleanup = hover(this.el, callback);
	}

	resetAnimationLock() {
		this.timeout = setTimeout(() => {
			this.canAnimate = true;
		}, 500);
	}

	spin() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(this.animationElement, {
				rotate: [0, 360],
			});

			this.resetAnimationLock();
		});
	}

	spin120() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(
				this.animationElement,
				{
					rotate: [0, -120],
				},
				{ type: "spring" },
			);

			this.resetAnimationLock();
		});
	}

	spinSlow() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(
				this.animationElement,
				{
					rotate: [0, 180],
				},
				{
					duration: 0.5,
					ease: [0, 0.64, 0.16, 1],
				},
			);

			this.resetAnimationLock();
		});
	}

	bounce() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(
				this.animationElement,
				{
					rotate: [0, 360],
					scale: [1, -1],
				},
				{ type: "spring" },
			);

			this.resetAnimationLock();
		});
	}

	shrinkTick() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(
				this.animationElement,
				{
					scale: [1, 0.5, 1],
					rotate: [0, 45, 180],
				},
				{
					ease: "easeInOut",
					duration: 0.6,
				},
			);

			this.resetAnimationLock();
		});
	}

	stretch() {
		this.setupHover(() => {
			if (!this.canAnimate) return;

			this.canAnimate = false;

			this.animation = animate(this.animationElement, {
				scaleY: [1, 1.3, 0.8, 1],
				scaleX: [1, 0.7, 1.3, 1],
			});

			this.resetAnimationLock();
		});
	}

	destroy() {
		if (this.hoverCleanup) {
			this.hoverCleanup();
			this.hoverCleanup = null;
		}

		if (this.timeout) {
			clearTimeout(this.timeout);
			this.timeout = null;
		}

		if (this.animation) {
			this.animation.stop();
			this.animation = null;
		}

		this.canAnimate = false;
	}
}

export default {
	init() {
		this.icons = Array.from(
			document.querySelectorAll("[data-icon-animation]"),
		).map((el) => new IconAnimation(el));
	},

	destroy() {
		if (!this.icons) {
			return;
		}

		this.icons.forEach((icon) => {
			icon.destroy();
		});

		this.icons = null;
	},
};
